import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { principalAPI, teacherAPI } from '../services/api';

const INBOX_ROLES = ['principal', 'school_admin', 'teacher'];

// Shared by ModernHeader.js (header badge) and PrincipalSidebar.js (bold nav
// item) so both reflect the true inbox unread count - not the notification
// bell's `inbox_message` type, which stays "unread" until the bell dropdown
// is opened even after the conversation itself has been read.
export default function useInboxUnreadCount() {
  const { user } = useAuth();
  const hasInbox = INBOX_ROLES.includes(user?.role);
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    if (!hasInbox) return;
    const inboxAPI = user?.role === 'teacher' ? teacherAPI.inbox : principalAPI.inbox;
    const fetchUnread = async () => {
      try {
        const res = await inboxAPI.getUnreadCount();
        setUnread(res.data.data.total);
      } catch (_) { /* non-critical */ }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 30000);
    return () => clearInterval(interval);
  }, [hasInbox, user?.role]);

  return hasInbox ? unread : 0;
}
